import BracketPerfectInfoContainer from './BracketPerfectInfoContainer';
export default BracketPerfectInfoContainer;
